/**
 * Public-facing URL builder. Customer WhatsApp / email shares must
 * always carry the HisaabPro brand (myhisaabpro.com) — NEVER the
 * Emergent / preview hostnames.
 *
 * Shape: https://myhisaabpro.com/d/{kind}/{id}?s={shop_id}
 * Frontend routes at /d/* fetch the backend PDF and stream it to the
 * customer without ever revealing the backend hostname.
 */

export const PUBLIC_URL =
  (process.env.REACT_APP_PUBLIC_URL || "https://myhisaabpro.com").replace(/\/+$/, "");

const _build = (kind, id, shopId) => {
  const q = shopId ? `?s=${encodeURIComponent(shopId)}` : "";
  return `${PUBLIC_URL}/d/${kind}/${encodeURIComponent(id)}${q}`;
};

export const buildPublicAgreementUrl = (agreementId, shopId) =>
  _build("agreement", agreementId, shopId);

export const buildPublicLedgerUrl = (customerId, shopId) =>
  _build("ledger", customerId, shopId);

export const buildPublicReceiptUrl = (paymentId, shopId) =>
  _build("receipt", paymentId, shopId);
